<template>
    <div>
        <div class="card bg-light mb-3">
            <div class="card-header bg-dark text-white text-left">
                <b-row>
                    <b-col>
                        <div v-if="!loading">
                            <font-awesome-icon icon="database" /><strong>&nbsp;{{list.total}}&nbsp;</strong>
                            <small>Result/s found</small>
                        </div>
                        <div v-else>
                            <strong>&nbsp;Fetching result...&nbsp;</strong>
                        </div>
                    </b-col>
                </b-row>
                
            </div>
            <div class="card-body bg-white">
                <b-row class="mb-3">
                    <b-col sm="3">
                        <b-form-select v-model="selected_display_no" :options="options" size="sm" @change="changeDisplayNo"></b-form-select>
                    </b-col>
                    <b-col sm="3">
                        <b-input-group>
                            <b-form-input
                                    type="date"
                                    class="form-control"
                                    placeholder="Search"
                                    autocomplete="off"
                                    size="sm"
                                    @keyup.native="searchDate"
                                    @change.native="searchDate"
                                    v-model="date"
                            />
                        </b-input-group>
                    </b-col>
                    <b-col sm="6">
                        <b-input-group>
                            <b-input-group-prepend>
                                <b-input-group-text class="bg-dark text-white"><font-awesome-icon icon="search" /></b-input-group-text>
                            </b-input-group-prepend>
                            <b-form-input
                                    type="text"
                                    class="form-control"
                                    placeholder="Search"
                                    autocomplete="off"
                                    size="sm"
                                    @keypress.native="searching"
                                    @keyup.native="search"
                                    v-model="search_term"
                            />
                            <b-input-group-append>
                                    <b-button @click="clearSearch" variant="dark" class="bg-dark text-white px-4" size="sm" :disabled="search_term==''">
                                        <font-awesome-icon icon="times" />
                                    </b-button>
                                    <!--<i class="fa fa-close"></i>-->
                            </b-input-group-append>
                        </b-input-group>
                    </b-col>
                </b-row>
                <b-table
                        selectable
                        selectedVariant="info"
                        select-mode="single"
                        :dark="dark"
                        :hover="hover"
                        :striped="striped"
                        :bordered="bordered"
                        :fixed="fixed"
                        responsive="sm"
                        :items="table_items"
                        :fields="captions"
                        :busy="loading"
                        show-empty
                        @row-dblclicked="rowDbClicked"
                        head-variant="dark"
                >
                    <div class="text-center  my-2" slot="table-busy">
                        <br>
                        <b-spinner small class="align-middle"></b-spinner>
                        <br><br>
                        <strong>Loading</strong>
                    </div>

                    <template v-slot:cell(id_number)="data">
                        <div class="text-left">
                            <span class="d-block bg-dark text-white p-1" style="min-width: 300px">ID Number : <strong>{{data.item.manpower_details.id_number}}</strong></span>
                            <span class="d-block p-1">Name : <strong>{{data.item.manpower_details.full_name}}</strong></span>
                            <span class="d-block p-1">Location : <strong>{{data.item.server_project_location_structure_item.description}}</strong></span>
                            <span class="d-block bg-dark text-white p-1">Structure : <strong>{{data.item.server_project_location_structure_item.project_location_structure.description}}</strong></span>
                            <span class="d-block p-1">Item : <strong>{{data.item.server_project_location_structure_item.project_location_structure.project_location.description}}</strong></span>
                            <span class="d-block bg-dark text-white p-1">Date : <strong>{{data.item.formatted_date.other_formats.format_1}}</strong></span>
                            <template v-if="data.item.json_export_id == null">
                                <b-badge variant="danger">
                                    Unprocessed
                                </b-badge>
                            </template>
                            <template v-else>
                                <b-badge variant="success">
                                    Processed - {{data.item.json_export.formatted_created_at.other_formats.format_3}}
                                </b-badge>
                            </template>
                        </div>
                    </template>
                    <template v-slot:cell(action)="data">
                        <div class="text-center">
                            <b-button
                                    variant="danger"
                                    size="sm"
                                    @click="deleteRow(data.item.id)"
                            >
                                <font-awesome-icon icon="minus-circle" /> Delete
                            </b-button>
                        </div>
                    </template>

                    <template v-slot:cell(am_in)="data">
                        <div class="text-center" v-if="data.item.formatted_am_in.default!=''">
                            <img
                                    class="cursor-pointer"
                                    :src="assets_path.EMPLOYEE_LOGS + data.item.am_in_image"
                                    width="200px"
                            />
                            <span class="d-block">{{data.item.formatted_am_in.other_formats.format_1}}</span>
                        </div>
                    </template>
                    <template v-slot:cell(am_out)="data">
                        <div class="text-center" v-if="data.item.formatted_am_out.default!=''">
                            <img
                                    class="cursor-pointer"
                                    :src="assets_path.EMPLOYEE_LOGS + data.item.am_out_image"
                                    width="200px"
                            />
                            <span class="d-block">{{data.item.formatted_am_out.other_formats.format_1}}</span>
                        </div>
                    </template>
                    <template v-slot:cell(pm_in)="data">
                        <div class="text-center" v-if="data.item.formatted_pm_in.default!=''">
                            <img
                                    class="cursor-pointer"
                                    :src="assets_path.EMPLOYEE_LOGS + data.item.pm_in_image"
                                    width="200px"
                            />
                            <span class="d-block">{{data.item.formatted_pm_in.other_formats.format_1}}</span>
                        </div>
                    </template>
                    <template v-slot:cell(pm_out)="data">
                        <div class="text-center" v-if="data.item.formatted_pm_out.default!=''">
                            <img
                                    class="cursor-pointer"
                                    :src="assets_path.EMPLOYEE_LOGS + data.item.pm_out_image"
                                    width="200px"
                            />
                            <span class="d-block">{{data.item.formatted_pm_out.other_formats.format_1}}</span>
                        </div>
                    </template>
                    <template v-slot:cell(ot_in)="data">
                        <div class="text-center" v-if="data.item.formatted_ot_in.default!=''">
                            <img
                                    class="cursor-pointer"
                                    :src="assets_path.EMPLOYEE_LOGS + data.item.ot_in_image"
                                    width="200px"
                            />
                            <span class="d-block">{{data.item.formatted_ot_in.other_formats.format_1}}</span>
                        </div>
                    </template>
                    <template v-slot:cell(ot_out)="data">
                        <div class="text-center" v-if="data.item.formatted_ot_out.default!=''">
                            <img
                                    class="cursor-pointer"
                                    :src="assets_path.EMPLOYEE_LOGS + data.item.ot_out_image"
                                    width="200px"
                            />
                            <span class="d-block">{{data.item.formatted_ot_out.other_formats.format_1}}</span>
                        </div>
                    </template>
                    <template v-slot:cell(status)="data">
                        <b-badge variant="danger" v-if="data.item.json_export_id == null">
                            Unprocessed
                        </b-badge>
                        <b-badge variant="success" v-else>
                            Processed
                        </b-badge>
                    </template>
                </b-table>
                <nav v-if="list.total>0">
                    <b-pagination
                            :disabled="loading"
                            @input="getAll"
                            align="right"
                            :total-rows="total_rows"
                            :per-page="per_page"
                            v-model="list.current_page"
                            class="mb-0"
                    >
                    </b-pagination>
                </nav>
            </div>
        </div>


    </div>
</template>

<script>
    import {bus} from '@/main.js'
    import SwalMixin from '@/views/mixins/Swal.js'
    import { assets_path } from "@/config";
    export default {
        name: 'server-side-paginated-table',
        inheritAttrs: false,
        mixins:[SwalMixin],
        props: {
            hover: {
                type: Boolean,
                default: true
            },
            striped: {
                type: Boolean,
                default: true
            },
            bordered: {
                type: Boolean,
                default: true
            },
            small: {
                type: Boolean,
                default: true
            },
            fixed: {
                type: Boolean,
                default: true
            },
            fields: {
                type: [Array, Object],
                default: () => []
            },
            dark: {
                type: Boolean,
                default: false
            },
            api_url: {
                type: String,
                required: true
            },
            delete_url: {
                type: String,
                required: true
            },
            top_right_btn: {
                type: String,
                default: '',
                required: false
            },
            top_right_btn_redirect: {
                type: Boolean,
                default: true,
                required: false
            },
        },
        data(){
            return {
                selected: [],
                list: {
                    data: [],
                    from: 1,
                    to: 0,
                    current_page: 1,
                    total: 0,
                    per_page: 1,
                },
                result:[],
                loading: true,
                searchTimeout: () => ({
                    type: Function,
                    default: () => ({})
                }),
                search_term: '',
                date: '',
                options: [
                    { value: 10, text: 'Display 10 records' },
                    { value: 25, text: 'Display 25 records' },
                    { value: 50, text: 'Display 50 records' },
                    { value: 100, text: 'Display 100 records' }
                ],
                selected_display_no:10,
                assets_path: {},
            }
        },
        computed: {
            table_items: function () {
                return this.list.data;
            },
            per_page: function () {
                return parseInt(this.list.per_page);
            },
            total_rows: function () {
                return parseInt(this.list.total);
            },
            captions: function () {
                return this.fields
            },
            total_selected: function () {
                return parseInt(this.selected.length);
            }
        },
        mounted() {
            this.assets_path = assets_path;
            this.getAll();
        },
        methods: {
            getAll() {
                this.loading = true;
                this.axios.get(this.api_url + '?page=' + this.list.current_page + '&per_page=' + this.selected_display_no + '&search=' + this.search_term+ '&date=' + this.date).then(response => {
                    // this.list = (response.data.data) ? response.data.data : response.data;
                    let result=response.data;
                    this.list=result
                    this.loading = false;
                    //console.log(result)
                }).catch(error => console.log(error));
            },
            clickTopRightBtn() {
                //this.$emit('openModal',this.selected);
                bus.$emit('serverSidePaginatedTableTopRightBtnClicked');
            },
            rowDbClicked(item) {
                bus.$emit('serverSidePaginatedTableDbClick',item);
            },
            searching() {
                this.loading = true;
                clearTimeout(this.searchTimeout);
            },
            search() {
                this.searchTimeout = setTimeout(() => {
                    this.list.current_page=1;
                    this.getAll();
                    clearTimeout(this.searchTimeout);
                }, 1000);
            },
            searchDate() {
                this.loading = true;
                this.list.current_page=1;
                this.getAll();
            },
            clearSearch(){
                this.search_term=''
                this.getAll();
            },
            changeDisplayNo(){
                this.loading = true;
                this.list.current_page=1;
                this.getAll();
            },
            deleteRow(row_id){
                this.swalConfirmDelete((data)=>{
                    if (data.value) {
                        this.loading=true;
                        this.axios.delete(this.delete_url,{ data: {id:row_id} }).then(response => {
                            this.getAll();
                            this.swal_transaction_completed_data.text="Record successfully deleted.";
                            this.swalTransactionCompleted();
                            this.loading=false;
                        }).catch(error => {
                            this.swalRequestError();
                            this.loading=false;
                        });
                    }
                });
            }
        }
    }
</script>
